const getStyles = (theme) =>({
  tableBorder: {
    border: '0.25px solid #707070',
    borderColor: '#707070'
  },
});

export default getStyles;
